import { Body } from 'copilot-design-system';
import { FunctionComponent } from 'react';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { CopilotBrandingIcon } from 'src/legacy/components/Icons';
import { PoweredByAssemblyBranding } from 'src/legacy/components/Icons/PoweredByAssemblyBranding';

export const AuthScreenPortalBadgeIcon: FunctionComponent = () => {
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();

  const iconClassName =
    'text-gray-small group-hover:text-black-heading ' +
    (isAssemblyBrandEnabled ? 'h-3.5' : 'h-[12px] w-[55px]');

  return isAssemblyBrandEnabled ? (
    <PoweredByAssemblyBranding className={iconClassName} />
  ) : (
    <>
      <Body className="text-[12px] text-gray-small group-hover:text-black-heading lining-nums tabular-nums">
        Powered by
      </Body>
      <CopilotBrandingIcon className={iconClassName} />
    </>
  );
};
